<template>
  <footer class="text-end text-white fixed-bottom"></footer>
</template>
